import { render, staticRenderFns } from "./r-item-table.vue?vue&type=template&id=467ed2c0"
import script from "./r-item-table.vue?vue&type=script&lang=js"
export * from "./r-item-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('467ed2c0')) {
      api.createRecord('467ed2c0', component.options)
    } else {
      api.reload('467ed2c0', component.options)
    }
    module.hot.accept("./r-item-table.vue?vue&type=template&id=467ed2c0", function () {
      api.rerender('467ed2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-table.vue"
export default component.exports